import { CheckInResponse, UserValidation, ValidationResponse } from "@/types/user";
import { apiSlice } from "@/redux/apiSlice";

export const User = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getValidateUser: builder.query<ValidationResponse, UserValidation>({
        query: (userdata) => ({
          url: `/user/${userdata.user_id}/validate?org_id=${userdata.org_id}&user_type=staff`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["User"],
      }),
      getCheckInInfo: builder.query<CheckInResponse, { user_id: number, hardware_key: string, org_id: number }>({  
        query: ({ user_id, hardware_key, org_id }) => ({
          url: `/checkin/user/${user_id}/info?hardware_key=${hardware_key}&org_id=${org_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: (result, error, arg) => [
          { type: 'User', id: `${arg.user_id}-${arg.hardware_key}` }
        ],
        // Add this to disable caching or force refetching
        keepUnusedDataFor: 0, // Don't keep data in cache
      }),

    };
  },
});

export const {
  useGetValidateUserQuery,
  useGetCheckInInfoQuery,
} = User;
